import React from "react"
import { Link, Outlet } from "react-router-dom"

export const RegisterDisplay = () => {
	return (
		<div className = "tw-w-full">
			<Outlet/>
		</div>
	)
}
